export const FONTS = [
  {
    family: "GreedBold",
    src: "url(/fonts/greed-bold.woff2)",
    display: "block",
  },
];

/** Datadog/log messages emitted by the PayPal Express Checkout hooks.
 * Technical, English-only, never shown to the buyer. Builder functions are
 * exposed for messages that include runtime context (basket id, status, etc.). */
export const SYSTEM_ERROR_MESSAGES = {
  MISSING_STRIPE_OR_ELEMENTS:
    "[PayPalExpressCheckout] Stripe or elements not found. PayPalExpressCheckout was probably not properly initialized in the parent component.",
  EXISTING_BASKET:
    "[PayPalExpressCheckout] a checkout is already in progress for this customer. Please wait a moment and try again.",
  CONFIRM_PAYMENT_FAILED:
    "[PayPalExpressCheckout] payment confirmation failed.",
  FORMS_ACTIONS_UNSUCCESSFUL:
    "ExpressCheckout: forms-actions returned an unsuccessful result.",
  createBasketFailed: (backendMessage: string) =>
    `[PayPalExpressCheckout] createBasket failed: ${backendMessage}`,
  basketConfirmedRequestFailed: (basketId: string) =>
    `[PayPalExpressCheckout] failed to confirm basket '${basketId}' with the back-end after Stripe confirm succeeded.`,
  basketConfirmedUnsuccessful: (basketId: string, status: string) =>
    `[PayPalExpressCheckout] basket '${basketId}' confirmation returned status '${status}'.`,
  missingProductForFlow: (flowSlug: string) =>
    `No product configured for flow ${flowSlug}`,
  missingCustomerIdForFlow: (flowSlug: string) =>
    `No customerId for flow ${flowSlug}`,
  v1ActionFailed: (message: string) =>
    `[useExpressCheckoutForV1] action failed: ${message}`,
  v2CheckoutApiFailed: (message?: string) => {
    const suffix = message ? `: ${message}` : "";
    return `[useExpressCheckoutForV2] checkout API failed${suffix}`;
  },
} as const;

/** PostHog boolean feature flag controlling visibility of the PayPal
 * Express Checkout button. The audience (e.g. KatKin-staff-only "private"
 * rollout) is configured on the PostHog dashboard via cohort / property
 * rules — the front-end just asks `isFeatureEnabled(...)` for the
 * currently-identified user. Read at the form-service field level
 * (`<FormPayPalExpressCheckout>`) so neither the dispatcher nor either
 * version's `useCreateBasket` mounts when the flag is off. */
export const PAYPAL_FEATURE_FLAG_NAME = "paypal-express-checkout";
